import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiService} from '../../shared';
import {Cultivo} from "../models/cultivos";

@Injectable({
  providedIn: 'root'
})
export class CultivosService extends ApiService<Cultivo> {
  protected dataKey = 'cultivos';
  protected objectKey = 'Cultivos';
  protected sendObjectKey = 'cultivos';
  protected sendObjectIdsKey = 'ids';

  constructor(protected httpClient: HttpClient) {
    super(Cultivo, httpClient, 'apiSeguroUrl');
  }
}
